import React from "react";

const SmallShape = ({ color = "#fff" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="174"
            height="193"
            viewBox="0 0 174 193"
        >
            <path
                id="Differenzmenge_163"
                data-name="Differenzmenge 163"
                d="M.253,193H0V0H174L140.116,0A49.262,49.262,0,0,0,100.1,20.552L14.134,140.345A74.034,74.034,0,0,0,.253,183.5V193Z"
                fill={color}
            />
        </svg>
    );
};

export default SmallShape;
